(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    module.directive('sharedAgendaFilter', ['AgendaFilterBroadcast', SharedAgendaFilterFn]);

    // filter directive for multiple shared agenda selection
    function SharedAgendaFilterFn(AgendaFilterBroadcast) {
        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/agenda/templates/shared-agenda-filter.template.html',
            scope: {
                sharedAgendas: '=',
                reloadLabelsFn: '&'
            }
        };
        return directive;
        function link(scope, element, attrs) {
            // broadcast listener
            var listener = null;
            // number of set filter
            scope.numFilters = 0;

            //activate directive
            activate();

            // filter list
            scope.filter = function ($event, agenda) {
                $event.stopPropagation();
                //reset
                scope.numFilters = 0;

                // agenda change
                if (agenda !== null) {
                    agenda.vmSelected = !agenda.vmSelected;
                    if (scope.reloadLabelsFn) {
                        scope.reloadLabelsFn();
                    }
                }

                // refresh view
                refresh();
            };

            // on destroy
            scope.$on('$destroy', function () {
                // unregister from broadcast
                if (listener) {
                    listener();
                    listener = null;
                }
            });

            // refresh view
            function refresh() {
                // number of selected states
                scope.numFilters = 0;
                for (var i = 0; i < scope.sharedAgendas.length; i++) {
                    if (scope.sharedAgendas[i].vmSelected) {
                        scope.numFilters++;
                    } //if
                }//for
            } // refresh

            // listen
            function listen() {
                //check for doing a refresh
                listener = scope.$on(AgendaFilterBroadcast.SharedAgendaRefresh, function () {
                    refresh();
                });
            } // listen

            // init work
            function activate() {
                // refresh view
                refresh();

                // listen
                listen();
            } //activate
        } // link
    }
})();